import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { capturarCampana } from "@/lib/campana";

// Aviso benigno de ResizeObserver (lo emiten HubSpot y otros embeds): diferimos
// los callbacks un frame para que no se produzca el bucle de notificaciones
// que dispara el overlay de error de desarrollo sobre el sitio.
if (typeof window.ResizeObserver !== "undefined") {
  const ObservadorOriginal = window.ResizeObserver;
  window.ResizeObserver = class extends ObservadorOriginal {
    constructor(callback) {
      super((entradas, observador) => {
        window.requestAnimationFrame(() => callback(entradas, observador));
      });
    }
  };
}

const esAvisoResizeObserver = (texto) =>
  typeof texto === "string" && texto.includes("ResizeObserver loop");

// "Script error." es lo unico que reporta el navegador cuando falla un script de
// otro dominio (HubSpot, mapas). No trae archivo ni linea: no es accionable y no
// debe tapar el sitio con el overlay de errores.
const esErrorOpacoDeTerceros = (e) =>
  e && typeof e.message === "string" &&
  e.message.replace(/\s+/g, " ").trim().toLowerCase().startsWith("script error") &&
  !e.filename;

window.addEventListener(
  "error",
  (e) => {
    if (esAvisoResizeObserver(e.message) || esErrorOpacoDeTerceros(e)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

// Solo el dominio publico puede indexarse: en cualquier otro host (preview,
// *.emergent.host) marcamos la pagina como noindex para buscadores que ejecutan JS.
if (!/(^|\.)sohareserve\.com$/i.test(window.location.hostname) &&
    !document.head.querySelector('meta[name="robots"]')) {
  const robots = document.createElement("meta");
  robots.setAttribute("name", "robots");
  robots.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");
  document.head.appendChild(robots);
}

// Atribución de campaña: se captura en el primer load, antes de cualquier navegación.
capturarCampana();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
